module.exports = __webpack_public_path__ + "img/BPPMP2.7a813e33.png";